import React, { useState } from "react";
import "./Cart.scss";
import Form from "./CheckoutForm/index";
import { useStateValue } from "../context/StateProvider";
import { actionTypes } from "../context/reducer";
import CartItem from "./CartItem";
import { Link } from "react-router-dom";

const TAX = 0.13;

const Cart = () => {
  const [{ products, cart }, dispatch] = useStateValue();
  const [mode, setMode] = useState(cart.length === 0 ? "empty" : "cart-items");

  if (products.length === 0)
    return (
      <main>
        <div className="loading-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </main>
    );

  const getProductById = (id) => {
    return products.find((product) => product.id === id);
  };

  const cartSubtotalArray = cart.map((product) => {
    const queriedProductID = getProductById(product.productId).price;
    const multiplier = queriedProductID ? queriedProductID : 0;
    return multiplier * product.quantity;
  });

  const handleClick = (action, labelId, quantity) => {
    if (quantity === 1 && action === "down") return false;
    if (action === "up") {
      dispatch({
        type: actionTypes.UPDATE_QUANTITY,
        labelId: labelId,
        quantity: quantity + 1,
      });
    } else {
      dispatch({
        type: actionTypes.UPDATE_QUANTITY,
        labelId: labelId,
        quantity: quantity - 1,
      });
    }
  };

  const handleRemove = (labelId) => {
    dispatch({
      type: actionTypes.REMOVE_FROM_CART,
      labelId,
    });
    // if (cartSubtotalArray.length <= 0) return setMode("empty");
  };

  return (
    <main className="cart">
      {/* <h1 className={`page-title ${mode === "empty" ? "empty-cart": ""}`}>Checkout</h1> */}
      {mode === "empty" && (
        <div className="cart-empty">
          <h1>Shopping cart is empty!</h1>{" "}
          <p>
            <Link className="label-link" to="/designwine">
              Design a label{" "}
            </Link>{" "}
            to add products to your cart
          </p>
        </div>
      )}
      {mode === "cart-items" && (
        <>
          <div className="shopping-cart-title">
            <p>Shopping Cart</p>
          </div>
          <div className="shopping-cart-items">
            <div className="shopping-cart-header">
              <div>Label Preview</div>
              <div>Product</div>
              <div className="quantity-subtotal">Quantity</div>
              <div className="quantity-subtotal">Subtotal</div>
            </div>
            {cart.map((product) => {
              const productInfo = getProductById(product.productId);

              return (
                <CartItem
                  product={product}
                  productInfo={productInfo}
                  handleRemove={handleRemove}
                  handleClick={handleClick}
                />
              );
            })}
            {/* {setMode === "cart-items" && (

            )} */}
            <div className="shooping-cart-totals">
              <div className="subtotal-titles">
                <h3>Subtotal: </h3>
                <h3>HST: </h3>
                <h4>TOTAL: </h4>
              </div>
              {cartSubtotalArray.length === 0 && setMode("empty")}
              <div className="subtotal-values">
                <h3>
                  $
                  {cartSubtotalArray.length > 0
                    ? cartSubtotalArray.reduce((a, b) => a + b)
                    : ""}
                </h3>
                <h3>
                  $
                  {cartSubtotalArray.length > 0
                    ? Math.floor(
                        cartSubtotalArray.reduce((a, b) => a + b) * TAX
                      )
                    : 0}
                </h3>
                <h4>
                  $
                  {cartSubtotalArray.length > 0
                    ? cartSubtotalArray.reduce((a, b) => a + b) +
                      Math.floor(
                        cartSubtotalArray.reduce((a, b) => a + b) * TAX
                      )
                    : ""}
                </h4>
                <button
                  className="new-btn"
                  onClick={() => setMode("shipping-information")}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {mode === "shipping-information" && <Form setCartMode={setMode} />}
    </main>
  );
};

export default Cart;
